module.exports = __webpack_public_path__ + "img/icon_1.e7daf46b.png";